/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'


export const createPersonnelUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/personnel-application/createUser`, param).then(res => res.data)
}
export const dropPersonnelUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/personnel-application/dropUser`, param).then(res => res.data)
}
export const grantPersonnelUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/personnel-application/grantUser`, param).then(res => res.data)
}
export const revokePersonnelUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/personnel-application/revokeUser`, param).then(res => res.data)
}
export const getPersonnelUsers = param => {
    return axiosInstance.post(`/api/gcadmin/v1/personnel-application/users`, param).then(res => res.data)
}
export const getPersonnelUserGrants = param => {
    return axiosInstance.post(`/api/gcadmin/v1/personnel-application/userGrants`, param).then(res => res.data)
}